import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import $ from "jquery";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faFileImport,
  faDownload,
  faSquarePlus,
  faCirclePlus,
} from "@fortawesome/free-solid-svg-icons";
import PageNotFound from "../../notfound";
import { Pagination } from "../../../Components/Pagination";

export default function PermissionGroups() {
  const { lang, proxy, auth, functions } = useSelector((state) => state);
  let navigate = useNavigate();
  const goToHomePage = () => {
    navigate(`/privileges`);
  };
  const { replaceString } = functions;
  const [groups, setGroups] = useState([]);
  const [views, setViews] = useState([]);
  const [group, setGroup] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const [isUpdate, setUpdate] = useState({
    state: false,
    data: "",
  });
  const debounceTimeout = useRef();
  const [user, setUser] = useState({});
  const _token = localStorage.getItem("_token");
  const message = useRef("");
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 14;

  const indexOfLastData = currentPage * rowsPerPage;
  const indexOfFirstData = indexOfLastData - rowsPerPage;
  const currentData = groups.slice(indexOfFirstData, indexOfLastData);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    if (isUpdate.state && isUpdate.data) {
      reset({
        group_name: isUpdate.data.group_name,
      });
    } else {
      reset({
        group_name: "",
      });
    }
  }, [isUpdate, reset]);

  // useEffect(() => {
  //   const stringifiedUser = localStorage.getItem("user");
  //   const username = stringifiedUser ? JSON.parse(stringifiedUser) : null;

  //   fetch(`${proxy()}/auth/u/${username}`, {
  //     headers: {
  //       Authorization: _token,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { success, data } = resp;
  //       if (success) {
  //         setUser(data);
  //       }
  //     });
  // }, []);

  useEffect(() => {
    const FetchDataAsync = async () => {
      const response = await fetch(`${proxy()}/privileges/groups`, {
        headers: {
          Authorization: _token,
        },
      });
      const serializedData = await response.json();
      const { groups } = serializedData;
      message.current = serializedData.message;
      if (groups && groups.length > 0) {
        setGroups(groups);
        setViews(groups);
      }
      setLoading(false);
    };

    FetchDataAsync();
  }, []);

  const handleCloseModal = () => {
    setGroup({
      name: "",
    });

    $("#add-group-modal-close").click();
  };

  const onSubmit = async ({ group_name }) => {
    if (isUpdate.state) {
      const request = await fetch(`${proxy()}/privileges/group`, {
        method: "PUT",
        headers: {
          Authorization: _token,
          "Content-type": "Application/json",
        },
        body: JSON.stringify({ group: { ...isUpdate.data, group_name } }),
      });

      const response = await request.json();
      const { success, data, content } = response;
      // console.log("WHATHREEsuccess", success);
      Swal.fire({
        title: success ? lang["success"] : lang["error"],
        text: content,
        icon: success ? "success" : "error",
        showConfirmButton: !success ? true : false,
        timer: 1500,
      });
      if (success) {
        setGroups((prev) => {
          const newPrev = [...prev];
          const index = newPrev.findIndex(
            (item) => item.id === isUpdate.data.id
          );
          if (index !== -1) {
            newPrev[index] = {
              ...newPrev[index],
              group_name,
            };
          }
          return newPrev;
        });
        // reset({
        //   group_name: group_name,
        // });
      }
    } else {
      const request = await fetch(`${proxy()}/privileges/create/group`, {
        method: "POST",
        headers: {
          Authorization: _token,
          "Content-type": "Application/json",
        },
        body: JSON.stringify({ group: { name: group_name } }),
      });

      const response = await request.json();
      const { success, data, content, message } = response;
      Swal.fire({
        title: success ? lang["success"] : lang["error"],
        text: content || lang[message],
        icon: success ? "success" : "error",
        showConfirmButton: !success ? true : false,
        timer: success ? 1500 : null,
      });
      if (success) {
        setGroups([...groups, data]);
        setUpdate({});
        reset();
      }
    }
  };

  const deleteTrigger = async (group) => {
    const { privilegegroup_id } = group;
    const request = await fetch(`${proxy()}/privileges/group`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify({ group: { privilegegroup_id } }),
    });

    const response = await request.json();

    const { success, content } = response;
    if (success) {
      const groupLeftBehind = groups.filter(
        (g) => g.privilegegroup_id != privilegegroup_id
      );
      setGroups(groupLeftBehind);
      Swal.fire({
        title: lang["success"],
        text: lang["success.delete"],
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      alert(content);
    }
  };

  if (
    !["pm", "uad"].includes(auth?.role) &&
    !auth?.ct?.find(
      ({ table_alias, read }) => table_alias === "privilegegroup" && read
    )
  ) {
    return <PageNotFound />;
  }
  const handleSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    if (value) {
      debounceTimeout.current = setTimeout(() => {
        const searchTerm = value.toLowerCase().trim();

        const list = views.filter((group) => {
          const groupName = group.group_name?.toLowerCase();
          const localizedTitle = lang[group.group_name]?.toLowerCase();
          return (
            groupName?.includes(searchTerm) ||
            localizedTitle?.includes(searchTerm)
          );
        });
        if (list.length > 0) {
          setGroups(list);
        } else {
          setGroups([]);
        }
      }, 1000);
    } else {
      setGroups(views);
    }
  };
  return (
    <div class="midde_cont" key={refresh}>
      <div class="container-fluid">
        <div class="row column_title">
          <div class="col-md-12">
            <div class="page_title d-flex align-items-center">
              <h4 class="ml-1">{lang["privileges groups"]}</h4>
              {["pm", "uad"].includes(auth?.role) ||
              auth?.ct?.find(
                ({ table_alias, write }) =>
                  table_alias === "privilegegroup" && write
              ) ? (
                <button
                  style={{ marginTop: 0 }}
                  type="button"
                  class="btn btn-primary custom-buttonadd ml-auto mr-4 btn-custom"
                  data-toggle="modal"
                  data-target="#quoteForm"
                >
                  <i class="fa fa-plus"></i>
                </button>
              ) : null}
            </div>
          </div>
        </div>

        <div class="row column1">
          <div class="col-md-12">
            <div
              class="white_shd full margin_bottom_30"
              style={{ marginBottom: "0" }}
            >
              <div
                class="full graph_head"
                style={{
                  borderBottom: " 1px solid rgb(221, 221, 221)",
                }}
              >
                <div class="heading1 margin_0">
                  <h5>
                    <label
                      // class="pointer"
                      style={{ margin: 0 }}
                      // onClick={() => navigate(-1)}
                    >
                      {/* <a title={lang["back"]}>
                        <i class=" fa fa-chevron-circle-left mr-1 nav-item nav-link"></i>
                      </a> */}
                      {lang["privilege groups list"]}
                    </label>
                  </h5>
                </div>
              </div>
              <div
                class="full price_table fix-height d-flex flex-column justify-content-between"
                style={{ height: "79vh", padding: "6px 12px" }}
              >
                <table class="table table ">
                  <thead>
                    <tr class="color-tr">
                      <th
                        class="font-weight-bold align-center"
                        scope="col"
                        width={1}
                      >
                        #
                      </th>
                      <th class="font-weight-bold" scope="col">
                        {lang["group name"]}
                      </th>
                      {["pm", "uad"].includes(auth?.role) ||
                      auth?.ct?.find(
                        ({ table_alias, update, delete: _d }) =>
                          table_alias === "privilegegroup" && (update || _d)
                      ) ? (
                        <th
                          class="font-weight-bold align-center _custom-width"
                          style={{ width: "8%" }}
                        >
                          {lang["log.action"]}
                        </th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td width={1}></td>
                      <td>
                        <input
                          type="search"
                          className="form-control"
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                      </td>
                      {["pm", "uad"].includes(auth?.role) ||
                      auth?.ct?.find(
                        ({ table_alias, update, delete: _d }) =>
                          table_alias === "privilegegroup" && (update || _d)
                      ) ? (
                        <td></td>
                      ) : null}
                    </tr>
                    {currentData && currentData.length > 0 ? (
                      currentData.map((group, index) => (
                        <tr key={index}>
                          <td width={1}>{indexOfFirstData + index + 1}</td>
                          <td>{group.group_name}</td>
                          {["pm", "uad"].includes(auth?.role) ||
                          auth?.ct?.find(
                            ({ table_alias, update, delete: _d }) =>
                              table_alias === "privilegegroup" && (update || _d)
                          ) ? (
                            <td style={{ width: "unset !important" }}>
                              <div className="row text-center">
                                {["pm", "uad"].includes(auth?.role) ||
                                auth?.ct?.find(
                                  ({ table_alias, update }) =>
                                    table_alias === "privilegegroup" && update
                                ) ? (
                                  <div class="icon-table">
                                    <div className="icon-table-line">
                                      <Link
                                        to={`/privileges/groups/${group.privilegegroup_id}`}
                                      >
                                        <i class="fa fa-edit icon-edit pointer size-24" />
                                      </Link>
                                    </div>
                                  </div>
                                ) : null}
                                {["pm", "uad"].includes(auth?.role) ||
                                auth?.ct?.find(
                                  ({ table_alias, delete: _d }) =>
                                    table_alias === "privilegegroup" && _d
                                ) ? (
                                  <div class="icon-table">
                                    <div
                                      className="icon-table-line"
                                      onClick={() => {
                                        Swal.fire({
                                          title: lang["confirm"],
                                          text: lang["confirm delete"],
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonText: lang["btn.delete"],
                                          cancelButtonText: lang["btn.cancel"],
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            deleteTrigger(group);
                                          }
                                        });
                                      }}
                                    >
                                      <i class="fa fa-trash icon-delete pointer size-24" />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </td>
                          ) : null}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="align-center">
                          {isLoading
                            ? null
                            : // <img
                            //   width={45}
                            //   className="mb-1"
                            //   src="/images/icon/load.gif"
                            //   alt="Loading..."
                            // />
                            message.current
                            ? lang[message.current]
                            : lang["not found data"]}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {currentData && currentData.length > 0 && (
                  <Pagination
                    total={groups.length}
                    itemsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    paginate={paginate}
                    lang={lang}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Modal add */}
        <div
          class="modal no-select-modal fade"
          id="quoteForm"
          tabindex="-1"
          role="dialog"
          aria-labelledby="quoteForm"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-lg modal-dialog-center"
            role="document"
          >
            <form
              class="modal-content p-md-3"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div class="modal-header">
                <h4 class="modal-title">
                  {isUpdate.state
                    ? lang["updatePriGroups"]
                    : lang["createPriGroups"]}
                </h4>
                <button
                  class="close"
                  id="add-group-modal-close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setUpdate({});
                    reset();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label
                        class="font-weight-bold text-small"
                        for="firstname"
                      >
                        {lang["privileges groups group_name"]}
                        <span className="red_star ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        {...register("group_name", { required: true })}
                      />
                      {errors.name && (
                        <p className="error-message">
                          {replaceString(lang["required"], [
                            lang["privileges groups group_name"],
                          ])}
                        </p>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="submit"
                  style={{ minWidth: "105px" }}
                  class="btn btn-success btn-custom"
                >
                  {isUpdate.state ? lang["btn.update"] : lang["btn.create"]}
                </button>
                <button
                  type="button"
                  style={{ minWidth: "105px" }}
                  onClick={() => {
                    reset();
                    setUpdate({});
                  }}
                  data-dismiss="modal"
                  class="btn btn-danger"
                >
                  {lang["btn.close"]}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
